// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    controllerType: z.string().min(1).max(32),
    controllerEntityId: z.string().min(1).max(128),
    idempotencyKeyHash: z.string().min(1).max(64),
    requestHash: z.string().min(1).max(64),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    challengeId: z.string().min(1).max(21),
    nonce: z.string().min(1).max(128),
    challengeExpiresAt: z.number(),
    retentionExpiresAt: z.number(),
    createdAt: z.number().optional(),
    updatedAt: z.number().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    controllerType: z.string().min(1).max(32),
    controllerEntityId: z.string().min(1).max(128),
    idempotencyKeyHash: z.string().min(1).max(64),
    requestHash: z.string().min(1).max(64),
    agentId: z.string().min(1).max(21),
    keyId: z.string().min(1).max(21),
    challengeId: z.string().min(1).max(21),
    nonce: z.string().min(1).max(128),
    challengeExpiresAt: z.number(),
    retentionExpiresAt: z.number(),
    createdAt: z.number(),
    updatedAt: z.number(),
});
export const AgentRegistrationRequests = Object.freeze({
    table: 'agent_registration_requests',
    tableSingular: 'agent_registration_request',
    fields: {
        tenantId: 'tenant_id',
        controllerType: 'controller_type',
        controllerEntityId: 'controller_entity_id',
        idempotencyKeyHash: 'idempotency_key_hash',
        requestHash: 'request_hash',
        agentId: 'agent_id',
        keyId: 'key_id',
        challengeId: 'challenge_id',
        nonce: 'nonce',
        challengeExpiresAt: 'challenge_expires_at',
        retentionExpiresAt: 'retention_expires_at',
        createdAt: 'created_at',
        updatedAt: 'updated_at',
    },
    fieldKeys: [
        'tenantId',
        'controllerType',
        'controllerEntityId',
        'idempotencyKeyHash',
        'requestHash',
        'agentId',
        'keyId',
        'challengeId',
        'nonce',
        'challengeExpiresAt',
        'retentionExpiresAt',
        'createdAt',
        'updatedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
